import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import EditAreaComp from '../../components/version-4/MasterForms/EditForms/EditAreaComp'
import { useArea } from '../../hooks/CompanyConfiguration/useArea'
import { ROUTES } from '../../shared/constants'
function EditArea() {
  const { area, getArea, updateArea } = useArea()

  const [areadata, setAreaData] = useState({
    name: '',
    region: '',
    zone: '',
    state1: '',
    district: '',
    city: '',
    areaCode: '',
    active: '',
  })
  const params = useParams()
  React.useEffect(() => {
    getArea({ areaId: params.areaId })
  }, [params.areaId])

  React.useEffect(() => {
    if (area) {
      setAreaData({
        name: area.name,
        region: area.region && area.region._id,
        zone: area.zone && area.zone._id,
        state1: area.state && area.state._id,
        district: area.district && area.district._id,
        city: area.city && area.city._id,
        areaCode: area.areaCode,
        active: area.active,
      })
    }
  }, [area])

  const handleArea = () => {
    updateArea({
      name: areadata.name,
      region: areadata.region,
      zone: areadata.zone,
      state: areadata.state1,
      district: areadata.district,
      city: areadata.city,
      areaCode: areadata.areaCode,
      active: areadata.active,
      areaId: params.areaId,
    })
  }
  return (
    <Layout heading="Area" heading2="Edit" url1={ROUTES.AREA} none>
      <HeaderTabLayout heading="Edit Area" state={areadata} setState={setAreaData} content={<EditAreaComp state={areadata} setState={setAreaData} />} addContent={handleArea} redirect={ROUTES.AREA} />
    </Layout>
  )
}

export default EditArea
